import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Logger Service
 *
 * Provides environment-aware logging to prevent sensitive data exposure in production.
 *
 * Usage:
 *   constructor(private logger: LoggerService) {}
 *   this.logger.log('Debug message', data);
 *   this.logger.warn('Warning message');
 *   this.logger.error('Error message', error);
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  /**
   * Log debug information (disabled in production)
   */
  log(message: string, ...args: any[]): void {
    if (!environment.production) {
      console.log(message, ...args);
    }
  }

  /**
   * Log debug information (disabled in production)
   */
  debug(message: string, ...args: any[]): void {
    if (!environment.production) {
      console.debug(message, ...args);
    }
  }

  /**
   * Log informational messages (disabled in production)
   */
  info(message: string, ...args: any[]): void {
    if (!environment.production) {
      console.info(message, ...args);
    }
  }

  /**
   * Log warning messages (disabled in production)
   */
  warn(message: string, ...args: any[]): void {
    if (!environment.production) {
      console.warn(message, ...args);
    }
  }

  /**
   * Log error messages (always enabled, even in production)
   */
  error(message: string, ...args: any[]): void {
    console.error(message, ...args);
  }
}
